import { View, ViewModel } from "binder";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class CurrencySelector extends SelectorBaseViewModel<Currency>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    protected async loadData(): Promise<Currency[]> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialRawDataServices/GetAllCurrencies',{
            });
            return result.Currencies.map(x=>{
                let r = new Currency(this);
                r.id=x.Id;
                r.title = `${x.Name}(${x.Symbol})`;
                return r;
            })
        } catch (ex) {
            console.log(ex);
            return Promise.resolve<Currency[]>([]);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class Currency extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}